<h1 mat-dialog-title>Außendienst für selektierte Tiere setzen</h1>
<div mat-dialog-content>
    <div class="one-row">
        <span class="spacer"></span>
        <mat-spinner *ngIf="isLoading"></mat-spinner>
        <span class="spacer"></span>
    </div>
    <ng-container *ngIf="!isLoading">
        <table>
            <tr>
                <td>Anzahl selektierte Tiere</td>
                <td
                    ><strong>{{ input.anzahlTiere }}</strong></td
                >
            </tr>
        </table>
        <p>Der ausgewählte Außendienst-Mitarbeiter wird für alle {{ input.anzahlTiere }} selektierten Tiere gesetzt.</p>

        <div style="display: flex; align-items: center; gap: 8px">
            <mat-form-field style="flex: 1">
                <mat-label>Außendienst-Mitarbeiter</mat-label>
                <mat-select [formControl]="aussendienstCtrl" placeholder="Außendienst-Mitarbeiter auswählen (optional)">
                    <mat-option [value]="null">
                        <em>Kein Außendienst zugewiesen</em>
                    </mat-option>
                    <mat-option *ngFor="let user of users" [value]="user">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <span>{{ user.vorname }} {{ user.nachname }}</span>
                            <span style="color: #666; font-size: 0.9em">
                                {{ user.titel ? "(" + user.titel + ")" : "" }}
                                {{ user.email ? " - " + user.email : "" }}
                            </span>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button
                mat-icon-button
                color="warn"
                (click)="removeAussendienst()"
                [disabled]="isLoading"
                matTooltip="Außendienst entfernen"
                style="margin-top: 8px"
            >
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </ng-container>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between; width: 100%; margin-top: 24px">
    <button (click)="save()" color="accent" mat-flat-button [disabled]="isLoading">Speichern</button>
    <button (click)="cancel()" mat-button>Abbrechen</button>
</div>
